export type StockTransferStatus = 'DRAFT' | 'PENDING_APPROVAL' | 'COMPLETED' | 'CANCELLED';

export const STOCK_TRANSFER_STATUS_LABELS: Record<StockTransferStatus, string> = {
    DRAFT: 'Draft',
    PENDING_APPROVAL: 'Pending Approval',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
};

export interface StockTransferLineDTO {
    id: string;
    stockTransferId: string;
    itemId: string;
    quantity: number;
    itemName: string;
    itemCode: string;
}

export interface StockTransferDTO {
    id: string;
    referenceNo: string;
    fromStoreId: string;
    toStoreId: string;
    institutionId: string;
    status: StockTransferStatus;
    transferDate: string;
    approvedById: string | null;
    approvedDate: string | null;
    completedDate: string | null;
    notes: string | null;
    fromStoreName: string;
    toStoreName: string;
    lines: StockTransferLineDTO[];
}

export interface StockTransferLineCreateDTO {
    itemId: string;
    quantity: number;
}

export interface StockTransferCreateDTO {
    fromStoreId: string;
    toStoreId: string;
    institutionId: string;
    transferDate?: string;
    notes?: string;
    lines: StockTransferLineCreateDTO[];
}

export interface StockTransferResponse {
    content: StockTransferDTO[];
    pageable: {
        pageNumber: number;
        pageSize: number;
        sort: {
            sorted: boolean;
            empty: boolean;
            unsorted: boolean;
        };
        offset: number;
        paged: boolean;
        unpaged: boolean;
    };
    last: boolean;
    totalPages: number;
    totalElements: number;
    size: number;
    number: number;
    sort: {
        sorted: boolean;
        empty: boolean;
        unsorted: boolean;
    };
    numberOfElements: number;
    first: boolean;
    empty: boolean;
}
